// Event for opening and closing the menu
export function mainNavigationToggle() {
	const toggles = Array.from(
		document.querySelectorAll('.main-navigation__menu-toggle'),
	);

	const secondaryToggles = Array.from(
		document.querySelectorAll(
			'.main-navigation .menu-item-has-children .menu-item__chevron',
		),
	);

	if (toggles) {
		toggles.forEach(function (toggle) {
			// Handle toggle click.
			toggle.addEventListener('click', function (e) {
				e.preventDefault();

				document.body.classList.toggle('main-navigation-menu-open');
			});
		});
	}

	// Secondary menu sub-menu toggles.
	if (secondaryToggles) {
		secondaryToggles.forEach(function (toggle) {
			// Handle toggle click.
			toggle.addEventListener('click', function (e) {
				e.preventDefault();

				toggle.parentNode.parentNode.classList.toggle('sub-menu--open');
			});
		});
	}

	const menuItems = Array.from(
		document.querySelectorAll('.main-navigation .menu-item-has-children'),
	);

	if (menuItems) {
		menuItems.forEach(function (menuItem) {
			const link = menuItem.querySelector(
				'.main-navigation .menu-item-has-children > a',
			);
			const subMenu = menuItem.querySelector(
				'.main-navigation .menu-item-has-children > .sub-menu',
			);

			const cloneItem = document.createElement('li');
			cloneItem.classList.add('menu-item', 'menu-item--clone');
			cloneItem.appendChild(link.cloneNode(true));

			if (subMenu) {
				subMenu.insertBefore(cloneItem, subMenu.firstChild);
			}

			// JS to calculate dropdown position on desktop.
			const desktopmq = window.matchMedia('screen and (min-width: 1024px)');
			menuItem.addEventListener('mouseover', function () {
				if (desktopmq.matches) {
					subMenu.style.removeProperty('left');
					const vw = Math.max(
						document.documentElement.clientWidth || 0,
						window.innerWidth || 0,
					);
					const subR = subMenu.getBoundingClientRect();
					if (subR.right > vw) {
						subMenu.style.left = `-${subR.right - vw + 20}px`;
					}
				}
			});
		});
	}
}

export function propertySearchToggle() {
	const toggle = document.querySelector('.property-search__label');

	if (toggle) {
		toggle.addEventListener('click', function () {
			document.body.classList.toggle('property-search-open');
		});
	}
}

// export function mobileCtaToggles() {
// 	const formToggle = document.querySelector('.mobile-cta__form-trigger');
// 	const formClose = document.querySelector('.mobile-cta__form-panel-close');

// 	if (formToggle) {
// 		formToggle.addEventListener('click', function () {
// 			document.body.classList.toggle('mobile-cta-form-panel-open');
// 		});
// 	}
// 	if (formClose) {
// 		formClose.addEventListener('click', function () {
// 			document.body.classList.remove('mobile-cta-form-panel-open');
// 		});
// 	}
// }
